package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.restaurant_tab.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.HorizontalScrollBehavior
import org.hs_soft.runmynesto.domain.config.LetterSpacing

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.overflowText
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.KitchenInfoHeaders
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.kitchen_info.ProductAdditions
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.restaurant_data.AdditionModel
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.components.HeaderTitle
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.SearchBarWithAddEditCloseIcon
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.ShowWhenListIsEmpty
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.vh

@Composable
fun KitchenInformation(
    listAddition: List<AdditionModel>?,
    kitchenInfoItems: List<ProductAdditions?>?,
    selectedKitchenInfoItem: ProductAdditions?,
    descending: Boolean?,
    windowSizeMode: WindowSizeModeEnum,
    onKitchenInfoTitleSortClick: () -> Unit,
    onSearchKitchenInfo: (String) -> Unit,
    onRefreshClick: () -> Unit,
    activeKitchenInfo: (String) -> Unit,
    deActivateKitchenInfo: (String) -> Unit,
    onAddClick: () -> Unit,
    onKitchenInfoItemClick: (ProductAdditions?) -> Unit,
    onEditKitchenInfoClick: () -> Unit,
    onDeleteKitchenInfoClick: () -> Unit,

)
{
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth()
    ){
        MediumContentTitle(
            title = Strings.current().kitchenInformation,
            marginTop = Dimen.largePadding,
        )

        SearchBarWithAddEditCloseIcon(
            onSearchInfo ={
                onSearchKitchenInfo(it)
            },
            onAddClick = {
                onAddClick()
            },
            onEditClick = {
                onEditKitchenInfoClick()
            },
            onDeleteClick = {
                onDeleteKitchenInfoClick()
            }

        )

        key(listAddition){
            KitchenInfoTable(
                windowSizeMode=windowSizeMode,
                kitchenInfoItems=kitchenInfoItems,
                selectedKitchenInfoItem=selectedKitchenInfoItem,
                descendingSort = descending,
                listAddition=listAddition,
                onKitchenInfoTitleSortClick = {
                    onKitchenInfoTitleSortClick()
                },
                onRefreshClick={
                    onRefreshClick()
                },
                onKitchenInfoItemClick = {
                    onKitchenInfoItemClick(it)
                },
                activateKitchenInfo = {
                    activeKitchenInfo(it)
                },
                deActivateKitchenInfo = {
                    deActivateKitchenInfo(it)
                }
            )
        }



    }
}




@Composable
private fun KitchenInfoTable(
    windowSizeMode: WindowSizeModeEnum,
    selectedKitchenInfoItem: ProductAdditions?,
    kitchenInfoItems: List<ProductAdditions?>?,
    listAddition: List<AdditionModel>?,
    descendingSort: Boolean?,
    onKitchenInfoTitleSortClick: () -> Unit,
    onRefreshClick: () -> Unit,
    activateKitchenInfo: (String) -> Unit,
    deActivateKitchenInfo: (String) -> Unit,
    onKitchenInfoItemClick: (ProductAdditions?) -> Unit,
) {
    if (windowSizeMode== WindowSizeModeEnum.Desktop){
        WindowTable(
            kitchenInfoItems = kitchenInfoItems,
            listAddition = listAddition,
            selectedKitchenInfoItem=selectedKitchenInfoItem,
            onKitchenInfoItemClick = {
                onKitchenInfoItemClick(it)
            },
            onRefreshClick = {
                onRefreshClick()
            },
            deActivateKitchenInfo = {
                deActivateKitchenInfo(it)
            },
            activateKitchenInfo = {
                activateKitchenInfo(it)
            },

        )
    }else{
        PhoneAndTabletTable(
            windowSizeMode=windowSizeMode,
            descendingSort=descendingSort,
            selectedKitchenInfoItem=selectedKitchenInfoItem,
            kitchenInfoItems = kitchenInfoItems,
            listAddition = listAddition,
            onKitchenInfoItemClick = {
                onKitchenInfoItemClick(it)
            },
            activateKitchenInfo = {
                activateKitchenInfo(it)
            },
            onKitchenInfoTitleSortClick = {
                onKitchenInfoTitleSortClick()
            },
            onRefreshClick = {
                onRefreshClick()
            },
            deActivateKitchenInfo = {
                deActivateKitchenInfo(it)
            }

        )
    }




}


@Composable
fun PhoneAndTabletTable(
    windowSizeMode: WindowSizeModeEnum,
    descendingSort: Boolean?,
    selectedKitchenInfoItem: ProductAdditions?,
    onKitchenInfoTitleSortClick: () -> Unit,
    kitchenInfoItems: List<ProductAdditions?>?,
    listAddition: List<AdditionModel>?,
    activateKitchenInfo: (String) -> Unit,
    onKitchenInfoItemClick: (ProductAdditions?) -> Unit,
    deActivateKitchenInfo: (String) -> Unit,
    onRefreshClick: () -> Unit,
)
{
    Row(
        modifier = Modifier
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .borderRadius(Dimen.semiLargeRadius)
            .padding(right = Dimen.normalPadding)
            .fillMaxWidth()
    )
    {

        Row(
            modifier = Modifier
                .fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        )
        {
            Column(
                modifier = Modifier
                    .borderRadius(
                        topLeft = Dimen.mediumBorderRadius,
                        bottomLeft = Dimen.mediumBorderRadius
                    )
                    .padding(left = Dimen.normalPadding)
                    .backgroundColor(Theme.ActionDisabledBackground.rgb)
                    .width(Constants.Responsive.KitchenTableHeaderWidth.vh)
            ) {
                HeaderTitles(
                    windowSizeMode=windowSizeMode,
                    descendingSort=descendingSort,
                    fillMaxWidth = false,
                    onKitchenInfoTitleSortClick={
                        onKitchenInfoTitleSortClick()
                    }
                )

            }

            if (kitchenInfoItems?.size==0){
                ShowWhenListIsEmpty()
            }else{
                Row(
                    modifier = HorizontalScrollBehavior.toModifier()
                        .fillMaxWidth()
                )
                {
                    kitchenInfoItems?.forEach {model->

                        val additionId= remember { mutableStateOf<String?>(null) }

                        val isChecked= model?.id?.let { id ->
                            listAddition?.any { it.productAdditionId == id } ?: false
                        } ?: false

                        LaunchedEffect(listAddition){
                            additionId.value = if (isChecked) {
                                listAddition?.find { it.productAdditionId == model?.id }?.id
                            } else {
                                null
                            }
                        }



                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .backgroundColor(
                                    if (selectedKitchenInfoItem?.id==model?.id)
                                        Theme.ActionSelected.rgb
                                    else Theme.White.rgb
                                )
                                .onClick {
                                    onKitchenInfoItemClick(model)
                                }
                        ) {


                            CheckboxComponent(
                                modifier = Modifier
                                    .margin(left = Dimen.normalPadding)
                                    .height(Dimen.kitchenInfoTitleHeight),
                                checkStatus =isChecked,
                                title = "",
                                onChecked = {
                                    activateKitchenInfo(model?.id ?: "")
                                },
                                onUnChecked = {
                                    deActivateKitchenInfo(additionId.value ?: "")
                                },
                            )

                            Separator()

                            InfoTitle(
                                modifier = Modifier
                                    .margin(left = Dimen.normalPadding),
                                title = model?.name ?: "",
                                width = Dimen.headerLargeWidth
                            )

                            Separator()

                            model?.variants?.forEachIndexed {position,it->
                                InfoTitle(
                                    modifier = Modifier.margin(
                                        left = Dimen.normalPadding,
                                    ),
                                    title = if (it.isNullOrEmpty()) "-" else it,
                                )
                                if (position!=model.variants.size-1)
                                    Separator()
                            }
                        }

                    }


                }
            }


        }


    }


}


@Composable
private fun WindowTable(
    kitchenInfoItems: List<ProductAdditions?>?,
    listAddition: List<AdditionModel>?,
    selectedKitchenInfoItem: ProductAdditions?,
    activateKitchenInfo: (String) -> Unit,
    deActivateKitchenInfo: (String) -> Unit,
    onKitchenInfoItemClick: (ProductAdditions?) -> Unit,
    onRefreshClick: () -> Unit,
) {
    val tableData = kitchenInfoItems?.map { model ->
        createTableRowData(model, listAddition)
    }

    CustomTable(
        columns = createTableColumns(activateKitchenInfo, deActivateKitchenInfo),
        data = tableData,
        isCustom = true,
        minHeight = Dimen.kitchenInfoItemsHeight,
        showRefreshButton = true,
        selectedId = selectedKitchenInfoItem?.id?:"",
        onRefresh = onRefreshClick,
        onRowClick = {id,_->
            val model = tableData?.find { it[KitchenInfoHeaders.ID.key] == id }
                ?.get(KitchenInfoHeaders.MODEL.key) as? ProductAdditions
            if (model != null) {
                onKitchenInfoItemClick(model)
            }
        }
    )
}

private fun createTableRowData(
    model: ProductAdditions?,
    listAddition: List<AdditionModel>?
): Map<String, Any?> {
    val additionId = listAddition?.find { it.productAdditionId == model?.id }?.id
    val isChecked = model?.id?.let { id ->
        listAddition?.any { it.productAdditionId == id } ?: false
    } ?: false

    val baseMap = mapOf(
        KitchenInfoHeaders.ID.key to model?.id,
        KitchenInfoHeaders.TITLE.key to model?.name,
        KitchenInfoHeaders.ACTIVATE.key to isChecked,
        KitchenInfoHeaders.ADDITION_ID.key to additionId,
        KitchenInfoHeaders.MODEL.key to model
    )

    // Add variant fields
    return (1..10).fold(baseMap) { acc, i ->
        val header = when (i) {
            1 -> KitchenInfoHeaders.VARIANT1
            2 -> KitchenInfoHeaders.VARIANT2
            3 -> KitchenInfoHeaders.VARIANT3
            4 -> KitchenInfoHeaders.VARIANT4
            5 -> KitchenInfoHeaders.VARIANT5
            6 -> KitchenInfoHeaders.VARIANT6
            7 -> KitchenInfoHeaders.VARIANT7
            8 -> KitchenInfoHeaders.VARIANT8
            9 -> KitchenInfoHeaders.VARIANT9
            else -> KitchenInfoHeaders.VARIANT10
        }
        acc + (header.key to model?.variants?.getOrNull(i - 1))
    }
}

private fun createTableColumns(
    activateKitchenInfo: (String) -> Unit,
    deActivateKitchenInfo: (String) -> Unit
): List<TableColumn> {
    val activateColumn = TableColumn(
        header = KitchenInfoHeaders.ACTIVATE.title,
        key = KitchenInfoHeaders.ACTIVATE.key,
        isSortable = false,
        customContent = { row ->
            {
                Box(modifier = Modifier.width(Dimen.headerSmallWidth)) {
                    CheckboxComponent(
                        modifier = Modifier.align(Alignment.Center),
                        checkStatus = row[KitchenInfoHeaders.ACTIVATE.key] as Boolean,
                        title = "",
                        onChecked = {
                            activateKitchenInfo(row[KitchenInfoHeaders.ID.key]?.toString() ?: "")
                        },
                        onUnChecked = {
                            deActivateKitchenInfo(row[KitchenInfoHeaders.ADDITION_ID.key]?.toString() ?: "")
                        }
                    )
                }
            }
        }
    )

    val titleColumn = TableColumn(
        header = KitchenInfoHeaders.TITLE.title,
        key = KitchenInfoHeaders.TITLE.key,
        isSortable = true,
//        width = Dimen.headerLargeWidth.value.toInt()
    )

    // Generate variant columns
    val variantColumns = (1..10).map { i ->
        val header = when (i) {
            1 -> KitchenInfoHeaders.VARIANT1
            2 -> KitchenInfoHeaders.VARIANT2
            3 -> KitchenInfoHeaders.VARIANT3
            4 -> KitchenInfoHeaders.VARIANT4
            5 -> KitchenInfoHeaders.VARIANT5
            6 -> KitchenInfoHeaders.VARIANT6
            7 -> KitchenInfoHeaders.VARIANT7
            8 -> KitchenInfoHeaders.VARIANT8
            9 -> KitchenInfoHeaders.VARIANT9
            else -> KitchenInfoHeaders.VARIANT10
        }

        TableColumn(
            header =header.title,
            key = header.key,
            isSortable = false,
        )
    }

    // Combine all columns
    return listOf(activateColumn, titleColumn) + variantColumns
}


@Composable
private fun HeaderTitles(
    windowSizeMode: WindowSizeModeEnum,
    descendingSort: Boolean?,
    fillMaxWidth: Boolean,
    onKitchenInfoTitleSortClick: () -> Unit,
) {
    HeaderTitle(
        title = Strings.current().activate,
        arrangement =if (windowSizeMode== WindowSizeModeEnum.Desktop) Arrangement.Center
        else Arrangement.Start,
        width = Dimen.headerSmallWidth,
    )

    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)


    HeaderTitle(
        title = Strings.current().title,
        width = Dimen.headerLargeWidth,
        descending = descendingSort,
        onTitleClick = {
            onKitchenInfoTitleSortClick()
        }
    )

    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    if (windowSizeMode== WindowSizeModeEnum.Desktop){
        Row(
            modifier = Modifier
                .fillMaxWidth()
        )
        {
            Variants(
                fillMaxWidth=fillMaxWidth,
                windowSizeMode=windowSizeMode,
            )
        }
    }else{
        Column(
            modifier = Modifier
                .fillMaxWidth()
        )
        {
            Variants(
                fillMaxWidth=fillMaxWidth,
                windowSizeMode = windowSizeMode
            )
        }
    }



}

@Composable
private fun SeparatorForTabletAndPhone(
    windowSizeMode: WindowSizeModeEnum
){
    if (windowSizeMode!= WindowSizeModeEnum.Desktop)
        Separator()
}

@Composable
private fun Variants(
    fillMaxWidth: Boolean,
    windowSizeMode: WindowSizeModeEnum
) {
    HeaderTitle(
        title = Strings.current().variant1,
        fillMaxWidth = fillMaxWidth,
    )
    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant2,
        fillMaxWidth = fillMaxWidth,
    )
    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant3,
        fillMaxWidth = fillMaxWidth,
    )
    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant4,
        fillMaxWidth = fillMaxWidth,
    )
    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant5,
        fillMaxWidth = fillMaxWidth,
    )
    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant6,
        fillMaxWidth = fillMaxWidth,
    )
    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant7,
        fillMaxWidth = fillMaxWidth,
    )

    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant8,
        fillMaxWidth = fillMaxWidth,
    )

    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant9,
        fillMaxWidth = fillMaxWidth,
    )

    SeparatorForTabletAndPhone(windowSizeMode=windowSizeMode)

    HeaderTitle(
        title = Strings.current().variant10,
        fillMaxWidth = fillMaxWidth,
    )
}

@Composable
private fun WindowKitchenInfoItem(
    model: ProductAdditions?,
    additionId: String,
    isChecked: Boolean,
    isLastItem: Boolean,
    activeKitchenInfo: (String) -> Unit,
    deActiveKitchenInfo: (String) -> Unit,
    onItemClick: (ProductAdditions?) -> Unit,
)
{

    Row(
        modifier = Modifier
            .onClick {
                onItemClick(model)
            }
            .fillMaxWidth()
            .thenIf(
                !isLastItem,
                Modifier
                    .borderBottom(
                        width = Dimen.smallThickness,
                        style = LineStyle.Solid,
                        color = Theme.ActionDisabledBackground.rgb
                    )
            )

            .padding(leftRight = Dimen.normalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {

        ItemContent(
            isChecked=isChecked,
            model=model,
            additionId=additionId,
            activeKitchenInfo={
                activeKitchenInfo(it)
            },
            deActiveKitchenInfo={
                deActiveKitchenInfo(it)
            },
        )


    }

}

@Composable
private fun ItemContent(
    isChecked: Boolean,
    activeKitchenInfo: (String) -> Unit,
    model: ProductAdditions?,
    deActiveKitchenInfo: (String) -> Unit,
    additionId:String,
) {

    Box(
        modifier = Modifier
            .width(
                Dimen.headerSmallWidth,
            )
    ) {
        CheckboxComponent(
            modifier = Modifier
                .align(Alignment.Center),
            checkStatus = isChecked,
            title = "",
            onChecked = {
                activeKitchenInfo(model?.id ?: "")
            },
            onUnChecked = {
                deActiveKitchenInfo(additionId)
            },
        )
    }


    InfoTitle(
        title = model?.name ?: "",
        width = Dimen.headerLargeWidth,
    )
    Row(
        modifier = Modifier.fillMaxWidth()
    ){
        model?.variants?.forEach {
            InfoTitle(
                title = if (it.isNullOrEmpty()) "-" else it,
                fillMaxWidth = true
            )
        }
    }

}

@Composable
private fun InfoTitle(
    modifier: Modifier=Modifier,
    title:String,
    width: CSSSizeValue<CSSUnit.px> =Dimen.headerMediumWidth,
    fillMaxWidth:Boolean=false,
)
{
    SpanText(
        text = title,
        modifier = modifier
            .width(width)
            .thenIf(
                fillMaxWidth,
                Modifier.fillMaxWidth()
            )
            .height(Dimen.kitchenInfoTitleHeight)
            .padding(topBottom = Dimen.smallPadding)
            .cursor(Cursor.Pointer)
            .fontWeight(FontWeight.Normal)
            .fontSize(FontSizes.semiMediumFontSize)
            .lineHeight(FontLineHeight.lineMedium)
            .letterSpacing(LetterSpacing.semiMedium)
            .fontFamily(FontFamily.Jakarta)
            .color(Theme.TextPrimary.rgb)
            .overflowText()
    )
}


